import type { CardSubscription } from '../cards.types';

const monthlyCharges = (amount: number, lastMonth: number) =>
  [0, 1, 2].map((offset) => ({
    at: new Date(Date.UTC(2026, lastMonth - 1 - offset, 11)).toISOString(),
    amount,
  }));

export const subscriptionsFixture: CardSubscription[] = [
  {
    id: 'sub-spotify',
    cardId: 'card-eur-main-9374',
    merchant: { name: 'Spotify', kind: 'logo' },
    cadence: 'monthly',
    amount: 9.99,
    nextChargeAt: '2026-06-11',
    charges: monthlyCharges(9.99, 5),
    blocked: false,
  },
  {
    id: 'sub-adobe',
    cardId: 'card-eur-main-9374',
    merchant: { name: 'Adobe Creative Cloud', kind: 'logo' },
    cadence: 'monthly',
    amount: 20,
    nextChargeAt: '2026-06-07',
    charges: monthlyCharges(20, 5),
    blocked: false,
  },
  {
    id: 'sub-netflix',
    cardId: 'card-eur-main-9374',
    merchant: { name: 'Netflix', kind: 'logo' },
    cadence: 'annual',
    amount: 99.99,
    nextChargeAt: '2027-01-15',
    charges: [{ at: '2026-01-15T00:00:00Z', amount: 99.99 }],
    blocked: false,
  },
  {
    id: 'sub-figma',
    cardId: 'card-eur-business-8829',
    merchant: { name: 'Figma', kind: 'logo' },
    cadence: 'monthly',
    amount: 45,
    nextChargeAt: '2026-06-02',
    charges: monthlyCharges(45, 5),
    blocked: false,
  },
];
